// src/app/services/notification.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private _isPanelOpen = new BehaviorSubject<boolean>(false);
  public isPanelOpen$ = this._isPanelOpen.asObservable();

  openPanel() {
    this._isPanelOpen.next(true);
  }

  closePanel() {
    this._isPanelOpen.next(false);
  }
}
